import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/prism/marts', label: 'Data Marts', testid: 'prism-nav-marts' },
];

export default function PrismShell() {
  return (
    <div className="hr-shell" data-testid="prism-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Prism Analytics</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
